var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddTicket = function SvgAddTicket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 44,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3AACC8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M20 14.5v15m7.5-7.5h-15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3AACC8",
    d: "M42 24.252a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5M42 26.752c-1.571 0-2.944.933-3.682 2.321-.303.57.175 1.179.82 1.179h5.726c.644 0 1.122-.61.82-1.179-.738-1.388-2.111-2.321-3.683-2.321"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3AACC8",
    strokeLinecap: "round",
    d: "M42 24.252a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5ZM42 26.752c-1.571 0-2.944.933-3.682 2.321-.303.57.175 1.179.82 1.179h5.726c.644 0 1.122-.61.82-1.179-.738-1.388-2.111-2.321-3.683-2.321Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3AACC8",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M39 17.5v-1a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2h-4"
  })));
};
export { SvgAddTicket as ReactComponent };
export default __webpack_public_path__ + "a421d784277e90de7c334cf32bfbb327.svg";